export default {
	language: 'แบบไทย',
	menu_1: 'หน้าแรก',
	menu_2: 'รายละเอียดสินค้า',
	menu_3: 'ขั้นตอนการใช้งาน',
	menu_4: 'จุดเด่นของเรา',
	menu_5: 'เกี่ยวกับเรา',
	menu_6: 'นโยบายความเป็นส่วนตัว',
	menu_7: 'ติดต่อเรา',
	banner_1: 'สินเชื่อแฟลช',
	banner_2: ' ภารกิจของเราคือการให้บริการสินเชื่อที่ปลอดภัยและสะดวกแก่ผู้ใช้',
	step_1: 'รายละเอียดสินค้า',
	step_2: '1.เงินกู้: ต้องเป็นคนไทยและมีบัตรประจำตัวประชาชน',
	step_3: '2.อายุ: มากกว่า 20 ปี',
	step_4: '3.เงินทุน : มีงานทำและแหล่งรายได้ที่มั่นคง',
	product_1: 'ขั้นตอนการใช้งาน',
	product_2: '1. ดาวน์โหลดแอปพลิเคชั่นสินเชื่อแฟลชและลงทะเบียนด้วยโทรศัพท์มือถือ',
	product_3: '2. กรอกข้อมูลส่วนตัวเพื่อที่เราจะสามารถปกป้องข้อมูลได้',
	product_4: '3. รอการตรวจสอบ',
	product_5: '4. หลังจากผ่านการตรวจสอบแล้ว เงินกู้สามารถเข้าบัญชีธนาคารของคุณได้โดยตรง',
	user_1: 'จุดเด่นของเรา',
	user_2: 'ไม่มีค่าธรรมเนียมแอบแฝง (โปร่งใส)',
	user_3: 'ชำระเงินสะดวก (ดำเนินการออนไลน์)',
	user_4: 'ปลอดภัยและเชื่อถือได้ (บริการสินเชื่อที่ปลอดภัยและเชื่อถือได้)',
	about_1: 'เกี่ยวกับเรา',
	about_2: 'คำอธิบายโดยย่อ: ภารกิจของเราคือการให้บริการสินเชื่อที่ปลอดภัยและสะดวกแก่ผู้ใช้',
	about_3: 'หากคุณมีคำถามหรือต้องการทราบข้อมูลเพิ่มเติมเกี่ยวกับสินเชื่อแฟลช โปรดติดต่อเราตามวิธีการดังต่อไปนี้',
	footer_1: 'ติดต่อเรา',
	footer_2: 'เวลาทำการ : จันทร์-ศุกร์ 09.00-18.00 น.',
	footer_3: 'huststorager.linyi@gmail.com',
	footer_4: '75/102 Ocean Tower 2, 37th Floor, Sukhumvit Soi 19,Bangkok 10110 Thailand',
	footer_5: 'สินเชื่อแฟลช',
	privacy: 'นโยบายความเป็นส่วนตัว',
	del_data_1: 'การใช้ฟังก์ชันการลบข้อมูลเพื่อความปลอดภัยของข้อมูลของคุณ คุณต้องยืนยันตัวตนของคุณ',
	del_data_2: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ',
	del_data_3: 'กรุณากรอกหมายเลขโทรศัพท์',
	del_data_4: 'กรุณากรอกรหัสผ่านสำหรับแอป',
	del_data_5: 'ขั้นตอนถัดไป',
	del_data_6: 'เรียนผู้ใช้',
	del_data_7: 'สวัสดี! ขอบคุณมากครับที่เลือกใช้แอพ ได้บาทง่ายๆ',
	del_data_8: 'ก่อนที่จะสมัครลบบัญชี โปรดตรวจสอบให้แน่ใจว่าคำสั่งซื้อของคุณทั้งหมดได้รับการชำระแล้ว และไม่มีคำสั่งซื้อที่อยู่ระหว่างการตรวจสอบ โปรดทราบว่าเมื่อลบบัญชีแล้ว จะไม่สามารถกู้คืนข้อมูลได้ โปรดยืนยันอย่างรอบคอบก่อนใช้งาน แอพนี้ไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นต่อทรัพย์สินส่วนบุคคล',
	del_data_9: 'หากคุณยืนยันว่าต้องการลบข้อมูลของคุณ โปรดคลิกปุ่มด้านล่าง',
	del_data_10: 'ยืนยันการลบ',
	del_data_11: 'โปรดป้อนรหัสยืนยันเพื่อยืนยันตัวตนของคุณ',
	del_data_12: 'กรุณากรอกรหัสยืนยัน 4 หลัก',
	del_data_13: 'ส่งอีกครั้ง',
	del_data_14: 'ตกลง',
	del_data_15: 'ข้อมูลของคุณถูกลบแล้ว!',
	del_data_16: 'การยืนยันบัตรประจำตัวประชาชน',
	del_data_17: 'กรุณากรอกบัตรประจำตัวประชาชนของคุณ',
	del_data_18: 'กำลังตรวจสอบ',
}
